import type { FilterDefinition } from "../config/structured-search-schema";

import { cn } from "@/lib/utils";

interface FieldOptionRowProps {
  field: FilterDefinition;
  highlighted: boolean;
  disabled?: boolean;
  onSelect?: () => void;
}

const FieldOptionRow = ({
  field,
  highlighted,
  disabled = false,
  onSelect,
}: FieldOptionRowProps) => {
  const Icon = field.icon;

  return (
    <li
      role="option"
      aria-selected={highlighted}
      aria-disabled={disabled}
      data-group-name={field.group}
      data-group-role="option"
      className={cn(
        "mx-2 flex min-h-12 items-center gap-2 rounded-lg px-2.5 py-2 text-sm leading-tight transition-colors",
        disabled
          ? "cursor-not-allowed text-slate-400 opacity-70"
          : "cursor-pointer hover:bg-slate-50",
        highlighted && !disabled ? "bg-slate-100 text-slate-900" : undefined,
        !highlighted && !disabled ? "text-slate-700" : undefined,
      )}
      onMouseDown={e => {
        e.preventDefault();
        if (!disabled) {
          onSelect?.();
        }
      }}
    >
      {Icon && (
        <div
          className={cn(
            "flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md border border-slate-200 bg-white shadow-sm shadow-slate-200/70",
            disabled ? "text-slate-300" : (field.iconClassName ?? "text-slate-500"),
          )}
        >
          <Icon className="h-3.5 w-3.5" />
        </div>
      )}
      <div className="flex min-w-0 flex-col">
        <span className="font-medium">{field.label}</span>
        {field.description && (
          <span className="text-[11px] text-slate-400">{field.description}</span>
        )}
      </div>
    </li>
  );
};

export default FieldOptionRow;
